<template>
  <Teleport to="body">
    <div class="fixed bottom-6 right-6 flex flex-col gap-3 z-[10000] pointer-events-none max-w-sm w-full outline-none" aria-live="polite">
      <TransitionGroup 
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto w-full bg-white border border-zinc-200 rounded-2xl shadow-2xl shadow-zinc-900/10 p-4 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] group cursor-pointer overflow-hidden relative"
          @click="removeToast(toast.id)"
        >
          <!-- Progress bar -->
          <div class="absolute bottom-0 left-0 h-0.5 bg-zinc-100 w-full opacity-50"></div>
          
          <div class="flex items-start gap-3">
            <div :class="[
              'w-8 h-8 rounded-xl flex items-center justify-center shrink-0 shadow-sm transition-transform duration-500 group-hover:rotate-12',
              toast.type === 'success' ? 'bg-emerald-500 text-white shadow-emerald-500/20' :
              toast.type === 'error' ? 'bg-red-500 text-white shadow-red-500/20' :
              toast.type === 'warning' ? 'bg-amber-500 text-white shadow-amber-500/20' :
              'bg-indigo-500 text-white shadow-indigo-500/20'
            ]">
              <CheckCircle2 v-if="toast.type === 'success'" class="w-4 h-4" />
              <AlertCircle v-else-if="toast.type === 'error'" class="w-4 h-4" />
              <AlertTriangle v-else-if="toast.type === 'warning'" class="w-4 h-4" />
              <Info v-else class="w-4 h-4" />
            </div>

            <div class="flex-1 pt-0.5">
              <p :class="[
                'text-[10px] font-black uppercase tracking-widest mb-0.5 antialiased',
                toast.type === 'success' ? 'text-emerald-600' :
                toast.type === 'error' ? 'text-red-600' :
                toast.type === 'warning' ? 'text-amber-600' :
                'text-indigo-600'
              ]">
                {{ 
                  toast.type === 'success' ? 'Opération réussie' : 
                  toast.type === 'error' ? 'Erreur critique' : 
                  toast.type === 'warning' ? 'Attention' : 
                  'Information' 
                }}
              </p>
              <p class="text-[13px] font-bold text-zinc-900 leading-snug antialiased">{{ toast.message }}</p>
            </div>

            <button class="text-zinc-300 hover:text-zinc-900 transition-colors p-1 -mr-1" @click.stop="removeToast(toast.id)">
              <X class="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { 
  CheckCircle2, AlertCircle, AlertTriangle, 
  Info, X 
} from 'lucide-vue-next'
import { useToast } from '../../composables/useToast.js'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
/* Scoped styles removed in favor of Tailwind */
</style>
